// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__uHrCE","colMin":"styles_colMin__3CDmE","colCheckbox":"styles_colCheckbox__3tC1a"};